var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../../_snowpack/pkg/react.js";

function SvgSunriseMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3 15.338C31.3 6.957 24.578.146 16.231.002 7.84-.142.837 6.56.63 14.951.493 20.484 3.298 25.41 7.637 28.22a4.822 4.822 0 011.44 1.426c1.754 2.718 3.485 5.635 5.284 10.78.53 1.518 2.674 1.515 3.204-.004 2.35-6.721 5.487-11.095 5.422-10.995.279-.43.645-.796 1.08-1.066 4.346-2.71 7.233-7.534 7.233-13.023zM18.054 45.908a2.092 2.092 0 11-4.183 0 2.092 2.092 0 014.183 0z",
    fill: "#F25C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.258 40.425c-1.798-5.144-3.53-8.061-5.284-10.78a4.82 4.82 0 00-1.44-1.425c-4.338-2.81-7.143-7.736-7.006-13.27C3.72 7.136 9.808.788 17.422.07a15.57 15.57 0 00-1.19-.067C7.838-.142.836 6.56.63 14.951.493 20.484 3.298 25.41 7.637 28.22a4.822 4.822 0 011.44 1.426c1.754 2.718 3.485 5.635 5.284 10.78.489 1.398 2.346 1.505 3.05.325-.06-.1-.111-.207-.153-.326zM16.382 45.908c0-.684.328-1.291.836-1.673a2.092 2.092 0 100 3.346 2.088 2.088 0 01-.836-1.673z",
    fill: "#E54A4A"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sunrise-marker_svg__clip0_366_92)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.175 26.35C10.013 26.35 5 21.337 5 15.175 5 9.013 10.013 4 16.175 4 22.337 4 27.35 9.013 27.35 15.175c0 6.162-5.013 11.175-11.175 11.175z",
    fill: "#B5728E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.033 15.175c0-5.648 4.211-10.33 9.658-11.072A11.183 11.183 0 0016.175 4C10.013 4 5 9.013 5 15.175c0 6.162 5.013 11.175 11.175 11.175.514 0 1.02-.036 1.516-.104-5.447-.742-9.658-5.423-9.658-11.071z",
    fill: "#776E99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.73 16.239h-3.807a.951.951 0 110-1.903h3.807a.951.951 0 110 1.903z",
    fill: "#DA7F7D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.505 16.239H6.699a.952.952 0 110-1.903h3.806a.951.951 0 110 1.903zM16.214 10.53a.952.952 0 01-.951-.952V5.772a.952.952 0 111.903 0v3.806a.951.951 0 01-.952.951z",
    fill: "#EBB58A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.214 10.53a.952.952 0 00.952-.952V5.772a.952.952 0 00-.952-.952v5.71zM19.578 11.923a.952.952 0 010-1.346l2.692-2.691a.951.951 0 111.345 1.346l-2.691 2.69a.951.951 0 01-1.346 0z",
    fill: "#DA7F7D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.504 11.923L8.813 9.232a.951.951 0 111.345-1.346l2.692 2.691a.952.952 0 01-1.346 1.346z",
    fill: "#EBB58A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.592 18.142H10.837a.952.952 0 01-.897-.634 6.641 6.641 0 01-.387-2.22 6.668 6.668 0 016.661-6.662 6.668 6.668 0 016.66 6.661c0 .75-.13 1.496-.386 2.22a.951.951 0 01-.896.635z",
    fill: "#FFF2BD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.592 18.142a.952.952 0 00.897-.634 6.642 6.642 0 00.386-2.22 6.668 6.668 0 00-6.66-6.662v9.516h5.377z",
    fill: "#EBB58A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "sunrise-marker_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 23,
    height: 23
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.175 26.35C10.013 26.35 5 21.337 5 15.175 5 9.013 10.013 4 16.175 4 22.337 4 27.35 9.013 27.35 15.175c0 6.162-5.013 11.175-11.175 11.175z",
    fill: "#00C3FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#sunrise-marker_svg__filter0_d_366_92)",
    mask: "url(#sunrise-marker_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.525 16.572h23.3l2.319 9.778H2.206l2.319-9.778z",
    fill: "#8DA8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.175 26.35h13.969l-2.319-9.778h-11.65v9.778z",
    fill: "#5689CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.817 25.322L28.525 16.5a.854.854 0 00-.834-.627H4.659a.854.854 0 00-.834.627l-2.292 8.822a.803.803 0 00.157.71c.163.2.413.318.677.318h27.616a.872.872 0 00.677-.318c.163-.2.22-.463.157-.71zm-3.08-5.037h-4.472l-.358-2.757h4.113l.716 2.757zm-12.421-2.757v2.757h-4.498l.358-2.757h4.14zm0 4.41v2.758h-5.071l.358-2.757h4.713zm1.718 0h4.713l.358 2.758h-5.07v-2.757zm0-1.653v-2.757h4.14l.358 2.757h-4.498zM5.33 17.528h4.114l-.359 2.757H4.614l.716-2.757zm-1.146 4.41h4.687l-.359 2.758H3.468l.716-2.757zm19.653 2.758l-.358-2.757h4.687l.716 2.757h-5.045z",
    fill: "#5689CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.525 16.5a.854.854 0 00-.834-.627H16.175V26.35h13.808a.872.872 0 00.677-.318c.163-.2.22-.463.157-.71L28.525 16.5zm-11.49 1.028h4.14l.357 2.757h-4.498v-2.757zm0 7.168v-2.757h4.712l.358 2.757h-5.07zm5.872-7.168h4.113l.716 2.757h-4.471l-.358-2.757zm.93 7.168l-.358-2.757h4.687l.716 2.757h-5.045z",
    fill: "#3A69C7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sunrise-marker_svg__clip0_366_92"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5 4)",
    d: "M0 0h22.35v22.35H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sunrise-marker_svg__filter0_d_366_92",
    x: -2.492,
    y: 15.873,
    width: 37.334,
    height: 18.477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_366_92"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_366_92",
    result: "shape"
  })))));
}

export default SvgSunriseMarker;